module.exports = __webpack_public_path__ + "static/img/catalog.ec247e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhsh/catalog.png
// module id = 0ySR
// module chunks = 13